/** Root wrapper around operation details tabs; keep in sync with scroll measurement selector. */
export const OPERATION_DETAILS_TABS_WRAPPER_CLASS = 'operation-details-tabs';

export const OPERATION_DETAILS_TABS_WRAPPER_SELECTOR = `.${OPERATION_DETAILS_TABS_WRAPPER_CLASS}`;

export const TAB_KEYS = {
  PRODUCTS: '1',
  APPLIED_AREA: '2',
  DETAILS: '3',
  WEATHER: '4',
  NOTES: '5'
} as const;

export const TAB_LABELS = {
  PRODUCTS: 'Products',
  APPLIED_AREA: 'Applied Area',
  DETAILS: 'Details',
  WEATHER: 'Weather',
  NOTES: 'Notes'
} as const;

export const TAB_TYPE = 'card' as const;
